/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './radiology-bill-item.reducer';

export const RadiologyBillItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const radiologyBillItemEntity = useAppSelector(state => state.radiologyBillItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="radiologyBillItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.radiologyBillItem.detail.title">RadiologyBillItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.radiologyBillItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{radiologyBillItemEntity.id}</dd>
          <dt>
            <span id="price">
              <Translate contentKey="tinyMedicRestApp.radiologyBillItem.price">Price</Translate>
            </span>
          </dt>
          <dd>{radiologyBillItemEntity.price}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.radiologyBillItem.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{radiologyBillItemEntity.discount}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.radiologyBillItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{radiologyBillItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.radiologyBillItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{radiologyBillItemEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.radiologyBillItem.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{radiologyBillItemEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.radiologyBillItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{radiologyBillItemEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.radiologyBillItem.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{radiologyBillItemEntity.timestampentry}</dd>
          <dt>
            <span id="statusCode">
              <Translate contentKey="tinyMedicRestApp.radiologyBillItem.statusCode">Status Code</Translate>
            </span>
          </dt>
          <dd>{radiologyBillItemEntity.statusCode}</dd>
          <dt>
            <span id="accessionNo">
              <Translate contentKey="tinyMedicRestApp.radiologyBillItem.accessionNo">Accession No</Translate>
            </span>
          </dt>
          <dd>{radiologyBillItemEntity.accessionNo}</dd>
          <dt>
            <span id="scheduledTime">
              <Translate contentKey="tinyMedicRestApp.radiologyBillItem.scheduledTime">Scheduled Time</Translate>
            </span>
          </dt>
          <dd>{radiologyBillItemEntity.scheduledTime}</dd>
          <dt>
            <span id="procedurePriority">
              <Translate contentKey="tinyMedicRestApp.radiologyBillItem.procedurePriority">Procedure Priority</Translate>
            </span>
          </dt>
          <dd>{radiologyBillItemEntity.procedurePriority}</dd>
          <dt>
            <span id="paidAmount">
              <Translate contentKey="tinyMedicRestApp.radiologyBillItem.paidAmount">Paid Amount</Translate>
            </span>
          </dt>
          <dd>{radiologyBillItemEntity.paidAmount}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyBillItem.scheduledAt">Scheduled At</Translate>
          </dt>
          <dd>{radiologyBillItemEntity.scheduledAt ? radiologyBillItemEntity.scheduledAt.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyBillItem.performedBy">Performed By</Translate>
          </dt>
          <dd>{radiologyBillItemEntity.performedBy ? radiologyBillItemEntity.performedBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyBillItem.referTo">Refer To</Translate>
          </dt>
          <dd>{radiologyBillItemEntity.referTo ? radiologyBillItemEntity.referTo.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyBillItem.diaglabBill">Diaglab Bill</Translate>
          </dt>
          <dd>{radiologyBillItemEntity.diaglabBill ? radiologyBillItemEntity.diaglabBill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyBillItem.radiologyPricing">Radiology Pricing</Translate>
          </dt>
          <dd>{radiologyBillItemEntity.radiologyPricing ? radiologyBillItemEntity.radiologyPricing.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyBillItem.radiologyStudy">Radiology Study</Translate>
          </dt>
          <dd>{radiologyBillItemEntity.radiologyStudy ? radiologyBillItemEntity.radiologyStudy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyBillItem.scheme">Scheme</Translate>
          </dt>
          <dd>{radiologyBillItemEntity.scheme ? radiologyBillItemEntity.scheme.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/radiology-bill-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/radiology-bill-item/${radiologyBillItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RadiologyBillItemDetail;
